import { useTheme } from "hooks/ThemeContext";
import { cn } from "../../lib/utils";

function Skeleton({ className, ...props }) {
  const { theme } = useTheme();
  return (
    <div
      className={cn(
        `${
          theme === "dark" ? "bg-grey-light" : "bg-background-secondary"
        } animate-pulse rounded-md`,
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
